/**
 * Error handling utilities for API calls and 401 authentication
 */

/**
 * Checks if an error is a 401 authentication error
 * @param {Error} error - The error object to check
 * @returns {boolean} - True if the error is a 401 error
 */
export const is401Error = (error) => {
  return error?.response?.status === 401 || error?.status === 401 || error?.statusCode === 401;
};

/**
 * Handles API errors in an authentication-aware way:
 * - Dispatches non-401 errors to the error handler for user feedback
 * - Re-throws ALL errors to allow 401s to reach the JWT interceptor for token refresh
 * @param {Error} error - The error object
 * @param {Function} dispatch - Redux dispatch function
 * @param {Function} errorAction - Redux action creator for handling errors
 * @throws {Error} - Always re-throws the error for interceptor handling
 */
export const handleApiError = (error, dispatch, errorAction) => {
  if (!is401Error(error)) {
    dispatch(errorAction(error));
  }
  throw error; // Always re-throw for 401 interceptor
};